export class GameVars {

    public static scaleY: number;
    public static correctionScale: number;
    public static gameData: GameData;
    public static currentScene: Phaser.Scene;
    public static pause: boolean;
    public static l: number;
    public static rows: number;
    public static cols: number;
    public static maze: any;
    public static score: number;
    public static currentLevel: number;
    public static cursorPosition: { r: number, c: number };
    public static goalPosition: { r: number, c: number };
    public static extraTimePosition: { r: number, c: number };
    public static validDirections: string[];
    public static levelCompleted: boolean;
    public static time: number;
    public static gameOver: boolean;
    public static path: { r: number, c: number }[];
    public static movingBackwards: boolean;
    public static justChangedDirection: boolean;
    public static pathColor: number;
    public static goalState: string;
    public static levelColourId: number;
    public static typeAd: string;
    public static languages: any;

    public static areValidDomains(domains: string[]): boolean {

        if (domains.length === 0) {
            return true;
        }

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static hexNumberToHexString(value: number): string {

        let a = value.toString(16);

        while (a.length < 6) {
            a = "0" + a;
        }

        return "#" + a;
    }

    public static padNumberToString(numberAsString: string): string {

        let answer = numberAsString;

        if (numberAsString.length === 1) {
            answer = "000" + numberAsString;
        } else if (numberAsString.length === 2) {
            answer = "00" + numberAsString;
        } else if (numberAsString.length === 3) {
            answer = "0" + numberAsString;
        }

        return answer;
    }

    public static formatTime(timeInSeconds: number): { str: string, h: string, m: string, s: string } {

        if (isNaN(timeInSeconds) || timeInSeconds > 24 * 3600) {
            return { str: "0:00:00", h: "00", m: "00", s: "00" };
        }

        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds - (hours * 3600)) / 60);
        const seconds = timeInSeconds - (hours * 3600) - (minutes * 60);

        let h = hours.toString();
        let m = minutes.toString();
        let s = seconds.toString();

        if (hours < 10) {
            h = "0" + hours;
        }

        if (minutes < 10) {
            m = "0" + minutes;
        }

        if (seconds < 10) {
            s = "0" + seconds;
        }

        return { str: h + ":" + m + ":" + s, h: h, m: m, s: s };
    }

    public static getLevelColours(id: number): { inner: number, outer: number } {

        switch (id) {
            case 0: { return { outer: 0xb2feff, inner: 0x00f1ff }; }
            case 1: { return { outer: 0xa6f737, inner: 0x73d149 }; }
            case 2: { return { outer: 0xffb00c, inner: 0xff6e05 }; }
            case 3: { return { outer: 0xff63be, inner: 0xff08d1 }; }
            case 4: { return { outer: 0xf94a8b, inner: 0xd8005f }; }
            default: { return { outer: 0xf94a8b, inner: 0xd8005f }; }
        }
    }
}
